import Repository from "./repository"

export default {
    /**
     * E-mail変更取得API
     *
     * @returns response
     */
    get() {
        return Repository.get("/api/s207-mail-changes/view");
    },
    /**
     * E-mail変更登録API
     *
     * @params params リクエストパラメータ
     * @returns response
     */
    post(params) {
        return Repository.post("/api/s207-mail-changes/add", params);
    },
    /**
     * E-mail変更実行API
     *
     * @params token リクエストパラメータ
     * @returns response
     */
    edit(token) {
        return Repository.post("/api/s207-mail-changes/edit", token);
    }
}